import api from './api'
import CategoryService from './CategoryService'
import CommonService from './CommonService'
import LiveService from './LiveService'
import MovieService from './MovieService'
import NewsService from './NewsService'
import OtherService from './OtherService'
import UserService from './UserService'
import WechatService from './WechatService'

const services = {
  common: new CommonService(),
  category: new CategoryService(),
  movie: new MovieService(),
  news: new NewsService(),
  user: new UserService(),
  other: new OtherService(),
  wechat: new WechatService(),
  lives: new LiveService(),
}

export default {
  ...services,
  install(Vue, options) {
    api.install(Vue)
    Object.keys(services).forEach(key => services[key].install(Vue))
    Vue.prototype.$service = this

    services.other.loadSetting()
  }
}



// WEBPACK FOOTER //
// ./src/service/index.js